import { useEffect } from "react";

const DEFAULT_DESC =
  "Dietico is a hospital diet assessor mobile app that connects hospital canteens, nurses and dieticians on one verified, timestamped record. DPDP Act 2023 compliant. Available on iOS and Android.";

function upsertMeta(attr, name, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Lightweight per-route SEO. Updates title, meta description,
 * canonical URL and OG/Twitter tags on client-side navigation.
 */
export default function useSeo({ title, description, path = "/" }) {
  useEffect(() => {
    const baseUrl = "https://dietico.co.in";
    const fullTitle = title
      ? `${title} — Dietico`
      : "Dietico — Hospital Diet Assessor App for Indian Hospitals | Mesron Healthcare LLP";
    const desc = description || DEFAULT_DESC;
    const canonical = `${baseUrl}${path}`;

    document.title = fullTitle;
    upsertMeta("name", "description", desc);
    upsertLink("canonical", canonical);

    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", desc);
    upsertMeta("property", "og:url", canonical);

    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", desc);
  }, [title, description, path]);
}
